module.exports = __webpack_public_path__ + "static/img/layout6.509850fe.png";